import TableContainer from "components/Common/TableContainer";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader } from "reactstrap";
import { formatDateStringToKorea } from "helpers/format";
import { USER_NOTIFICATION_ALLOW_TYPE_OPTION } from "helpers/constans";
import PushNotificationApi from "api/notificationApi";

interface ModalPerNotificationProps {
  header?: string;
  userID?: string;
  isOpen?: boolean;
  onClose?: () => void;
}

const ModalPerNotification = ({
  header,
  userID,
  onClose,
}: ModalPerNotificationProps) => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 40,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 30 }}>
              {props?.row?.index + 1}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "allow_status",
        filterable: true,
        sortable: false,
        thWidth: 80,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let item = cell?.row?.original;

          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
              // style={{ width: 80 }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="is_active"
                checked={cell?.value}
                onChange={(e) => {
                }}
              />
              </div>
          );
        },
      },
      {
        Header: t("Type"),
        accessor: "type",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const type = cell?.value;
          return (
            <div style={{ minWidth: 80 }}>
              {t(
                USER_NOTIFICATION_ALLOW_TYPE_OPTION?.find(
                  (item: any) => String(item?.value) === String(type)
                )?.label || ""
              )}
            </div>
          );
        },
      },
      {
        Header: t("Description"),
        accessor: "description",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let description = cell?.value;
          return description ? (
            <div>
              {description}
            </div>
          ) : '-';
        },
      },
      {
        Header: t("Priority"),
        accessor: "priority",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap text-center",
        Cell: (cell: any) => {
          let priority = cell?.value;

          return (
            <div
              className="d-flex justify-content-center align-items-center form-check me-3"
            >
              {priority ?? '-'}
            </div>
          );
        },
      },
      {
        Header: t("Sound"),
        accessor: "sound",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap text-center",
        Cell: (cell: any) => {
          let sound = cell?.value;

          return (
            <div
              className="d-flex justify-content-center align-items-center form-check me-3"
            >
              {sound ?? '-'}
            </div>
          );
        },
      },
      {
        Header: t("Last Update Permission"),
        accessor: "last_update_permission",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const lastLoginTime = cell?.value;
          const date = formatDateStringToKorea(lastLoginTime);

          const arrDate = String(date || "").split(" ");

          return lastLoginTime ? (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          ) : <div className="text-end">-</div>;
        },
      },
      {
        Header: t("Last Push"),
        accessor: "last_push",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const lastPush = cell?.value;
          const date = formatDateStringToKorea(lastPush);

          const arrDate = String(date || "").split(" ");

          return lastPush ? (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          ) : <div className="text-end">-</div>;
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language]
  );

  const handleCloseConfirmClick = () => {
    onClose && onClose();
  };

  useEffect(() => {
    const handleCallAllOption = async () => {
      if(!userID) return;

      try {
        const [settings]: any = await Promise.all([
          PushNotificationApi.getNotificationSettings(userID)
        ]);
        setData((_prev: any) => settings?.data?.list || []);

      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, [userID]);

 
  return (
    <React.Fragment>
      <Modal
        isOpen={true}
        centered={true}
        size="xl"
        toggle={handleCloseConfirmClick}
        keyboard={true}
        scrollable={false}
      >
        <ModalHeader toggle={handleCloseConfirmClick}>
          {header ?? t("Allow Notification")}
        </ModalHeader>
        <ModalBody className="">
          <div className="row g-4">
            <Col sm={12}>
              <div className="p-3">
                <TableContainer
                  className="custom-header-css"
                  divClass="table-responsive table-card"
                  tableClass="align-middle table-bordered-dashed"
                  theadClass="table-light text-muted"
                  columns={columns}
                  data={data ?? []}
                  manualSorting={true}
                  isShowPagination={false}
                />
              </div>
            </Col>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ModalPerNotification;
